import { render } from "./ControlsMenuComponent.vue?vue&type=template&id=c6f29b7a&ts=true"
import script from "./ControlsMenuComponent.vue?vue&type=script&lang=ts"
export * from "./ControlsMenuComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__